"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyButtons = void 0;
const react_next_1 = require("@geome/react-next");
const react_1 = __importStar(require("react"));
const StickyButtons = ({ directionsLink, locatorLink, offersLength, shown, }) => {
    const className = (0, react_next_1.useBEM)({
        block: "sticky-buttons",
        modifiers: {
            shown: shown,
        },
    });
    const { translate } = (0, react_next_1.useI18n)();
    const { isMobile } = (0, react_1.useContext)(react_next_1.EnvironmentContext);
    if (isMobile)
        return null;
    return (react_1.default.createElement("div", { className: className, "aria-hidden": true },
        react_1.default.createElement("div", { className: "sticky-buttons__container" },
            react_1.default.createElement("a", { className: "sticky-buttons__button", href: directionsLink }, translate("station_page.sections.info.get_directions")),
            offersLength > 0 && (react_1.default.createElement("a", { className: "sticky-buttons__button", href: "#offers-anchor" }, translate("station_page.sections.info.offers"))),
            react_1.default.createElement("a", { className: "sticky-buttons__button sticky-buttons__button--fit-content", href: locatorLink }, translate("station_page.sections.info.station_locator")))));
};
exports.StickyButtons = StickyButtons;
